import React, { useEffect, useState } from 'react';

const AdminKvkk = () => {
  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${apiBase}/backend/api.php?action=getKvkk`);
        const data = await res.json();
        setContent(data?.content || '');
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      setMessage('');
      const res = await fetch(`${apiBase}/backend/api.php?action=upsertKvkk`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content })
      });
      const data = await res.json();
      if (data?.success) {
        setMessage('KVKK metni başarıyla kaydedildi.');
        setTimeout(() => setMessage(''), 2500);
      } else {
        setMessage('Kaydetme sırasında bir sorun oluştu.');
      }
    } catch (e) {
      console.error(e);
      setMessage('Kaydetme sırasında bir hata oluştu.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">KVKK Metni</h1>
        <a
          className="text-sm text-blue-600 hover:underline"
          href="/kvkk"
          target="_blank"
          rel="noreferrer"
        >
          Önizle
        </a>
      </div>

      {loading ? (
        <div>Yükleniyor...</div>
      ) : (
        <>
          <label className="block text-sm font-medium text-gray-700 mb-2">İçerik (HTML desteklenir)</label>
          <textarea
            className="w-full border rounded-md p-3 min-h-[320px]"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="KVKK aydınlatma metnini giriniz..."
          />

          {message && (
            <div className="mt-3 text-sm text-green-700 bg-green-50 border border-green-200 rounded px-3 py-2">{message}</div>
          )}

          <div className="mt-4">
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-60"
            >
              {saving ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminKvkk;





















